import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Select,
  message,
  Carousel,
  BackTop,
} from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import $ from "jquery";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";
//import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import NewCar from "../images/new-car-transparent.png";
import UsedCar from "../images/used-car-transparent.png";
import DemoCar from "../images/demo-car-transparent.png";
import ThinkImg from "../images/man-thinking.png";
import CurrencyFormat from "react-currency-format";
import { connect } from "react-redux";
import {
  fetchSingleStock,
  addToWishList,
  removeFromWishList,
} from "../redux/actions";
function onChange(a, b, c) {
  console.log(a, b, c);
}
if (window.innerWidth <= 770 || window.innerHeight <= 440) {
  window.isPhone = true;
} else {
  window.isPhone = false;
}
const { Option } = Select;
const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  cssEase: "linear",
  responsive: [
    ,
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
function compareStrings(a, b) {
  a = a;
  b = b;

  return a < b ? -1 : a > b ? 1 : 0;
}
const { Meta } = Card;
const onClickBranch = ({ key }) => {
  message.info(`Website Coming Soon!`);
};
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInWishList: false,
      stock: props.stock,
      isHovered: false,
      stock: [],
    };
  }
  getFilters(filters) {
    this.props.stockfilters(filters);
  }

  ToggleCarWishlist(event) {
    var stock = JSON.parse(event.target.id);
    if (!this.state.isInWishList) {
      this.props.addToWishList(stock);
      this.setState({ isInWishList: true });
    } else {
      this.props.removeFromWishList(stock);
      this.setState({ isInWishList: false });
    }
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    window.updateCarousel();
    window.reRenderRangeSlider();
    var stock = this.props.stock;
    fetch(
      "https://www.devvcsappcloud.com/mtgroup/api/stock/findallstockclient",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      }
    ).then(async (res) => {
      const result = await res.json();
      this.setState({
        stock: result.allStock.sort(function (a, b) {
          return compareStrings(a.make, b.make);
        }),
      });
    });

    //if (
    //  this.props.wishlistproducts.filter(function (e) {
    //    return e._id === stock._id;
    //  }).length === 1
    //) {
    //  this.setState({ isInWishList: true });
    //}
  }
  mouseHover(event) {
    this.setState({ isHovered: true });
  }

  mouseUnHover(event) {
    this.setState({ isHovered: false });
  }

  render(props, stock) {
    //var heartStyle = {};
    //if (!this.state.isHovered) {
    //  heartStyle = {
    //    color: "#F91700",
    //    fontWeight: "bold",
    //  };
    //}
    const duplicateCheck = [];
    return (
      <div>
        <div className='wrap-body-inner desktop-view'>
          <div>
            {/*<section className='block-sl'>
            <div className='container-custom'>
              <div className='row'>
                <div className='col-sm-5 col-md-5 col-lg-5'>
                  <div className='banner-item-home banner-2x-home no-bg color-inher-home'>
                    <h1 className='f-weight-600'>
                      PURCHASE YOUR <br />
                    </h1>
                    <h1 style={{ color: "red" }}>PERFECT STOCK</h1>
                    <p>
                      Mega Theron Group makes it easy to drive your dream
                      stock at the best prices possible.
                    </p>
                    <Link
                  to={"/stock"}
                  className="ht-btn ht-btn-default ht-btn-2x m-t-lg-35"
                >
                  View all stock
                </Link>
                  </div>
                </div>
                <div className='col-sm-6 col-md-6 col-lg-6'>
                  <img
                    className='banner-img-home'
                    style={{ width: "50em" }}
                      src={`${process.env.PUBLIC_URL}/images/home-banner.png`}
                    alt='logo'
                  />
                </div>
              </div>
            </div>
          </section>*/}
            {/*<SearchBarHome filters={this.getFilters.bind(this)} />*/}
          </div>
          <div className='product product-grid product-grid-2 stock m-t-lg-50 p-t-sm-35 m-b-lg-20 '>
            <div className='heading'>
              <h3>Promotions</h3>
            </div>
            <div className='row'>
              <Slider {...settings}>
                {this.state.stock.map((stock, index, props) => {
                  return stock.webVisible && stock.homeVisible ? (
                    <div className='col-lg-12' key={index}>
                      <div className='product-item hover-img '>
                        {/*<i
                          id={JSON.stringify(stock)}
                          //className={
                          //  this.state.isInWishList ? "fa fa-heart" : "fa fa-heart-o"
                          //}
                          className={"fa fa-heart"}
                          style={{
                            background: "#ecececbe",
                            borderRadius: "0em 0em 0em 0.8em",
                            padding: "1em",
                            position: "absolute",
                            right: 0,
                            top: 0,
                            color: this.state.isInWishList ? "red" : "grey",
                          }}
                          onClick={this.ToggleCarWishlist.bind(this)}
                        />*/}
                        {stock.onSale === true ? (
                          <span
                            style={{
                              background: "rgb(254, 95, 92)",
                              borderRadius: "5em",
                              padding: "0.7em",
                              paddingTop: "1.1em",
                              paddingBottom: "1em",
                              position: "absolute",
                              left: 10,
                              top: 10,
                              color: "white",
                              fontSize: 11,
                            }}
                          >
                            SALE
                          </span>
                        ) : null}
                        {stock.condition ? (
                          <span
                            style={{
                              background:
                                stock.condition === "New"
                                  ? "rgba(254, 95, 92, 0.829)"
                                  : stock.condition === "Demo"
                                  ? "rgba(109, 109, 109, 0.829)"
                                  : "rgba(109, 109, 109, 0.829)",
                              borderRadius: "0em",
                              padding: "0.3em",
                              paddingRight: "0.8em",
                              paddingLeft: "0.8em",
                              position: "absolute",
                              right: 10,
                              top: 158,
                              width: "4.3em",
                              color: "white",
                            }}
                          >
                            {stock.condition.toUpperCase()}
                          </span>
                        ) : null}
                        {stock.modelYear ? (
                          <span
                            style={{
                              background: "rgba(0, 0, 0, 0.529)",
                              borderRadius: "0em",
                              padding: "0.3em",
                              paddingRight: "0.8em",
                              paddingLeft: "0.8em",
                              position: "absolute",
                              right: stock.condition ? 75 : 10,
                              top: 158,
                              color: "white",
                            }}
                          >
                            {stock.modelYear}
                          </span>
                        ) : null}
                        <Link
                          className='product-img'
                          onClick={() => this.props.fetchSingleStock(stock)}
                          to={`/stocko`}
                        >
                          {stock.frontLeftImage ? (
                            <img
                              src={`${process.env.REACT_APP_GLOBAL_SERVER}mtgroup/api/images/${stock.frontLeftImage}`}
                              alt=''
                            />
                          ) : (
                            <img
                              src={`${process.env.PUBLIC_URL}/images/coming-soon.png`}
                              alt=''
                            />
                          )}
                        </Link>
                        <div className='product-caption'>
                          <h4
                            className='product-name'
                            style={{ marginBottom: "0em", marginTop: "-1em" }}
                          >
                            <Link
                              onClick={() => this.props.fetchSingleStock(stock)}
                              to={`/stocko`}
                            >
                              <span style={{ display: "block" }}>
                                {stock.make}
                                <p
                                  className='f-14'
                                  style={{
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    paddingRight: "3em",
                                    overflow: "hidden",
                                    width: "21em",
                                  }}
                                >
                                  {/*{stock.series} 
                              <br />*/}
                                  {stock.modelDesc}
                                </p>
                              </span>
                            </Link>
                          </h4>
                          <div className='product-name'>
                            <span
                              className='f-15 m-t-lg-5'
                              style={{
                                float: "left",
                                textAlign: "left",
                                fontWeight: 400,
                                color: "black",
                              }}
                            >
                              {stock.branchImage ? (
                                <img
                                  src={`${process.env.REACT_APP_GLOBAL_SERVER}mtgroup/api/images/${stock.branchImage}`}
                                  alt=''
                                  style={{
                                    position: "absolute",
                                    marginTop: "-2.3em",
                                    objectFit: "cover",
                                    height: "2em",
                                  }}
                                />
                              ) : (
                                <span
                                  style={{
                                    textAlign: "left",
                                    position: "absolute",
                                    marginTop: window.isPhone
                                      ? "-2em"
                                      : "-1.5em",
                                    left: 0,
                                  }}
                                >
                                  {stock.brand}
                                </span>
                              )}
                              {stock.branch}
                            </span>
                            <span
                              className='f-23  m-t-lg-0 mn-cl'
                              style={{ float: "right" }}
                            >
                              <CurrencyFormat
                                value={stock.price}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"R"}
                                //format='R### ### ### ###'
                                renderText={(value) => <div>{value}</div>}
                              />
                            </span>
                          </div>
                          <ul className='static-caption m-t-lg-20'>
                            <li>
                              <i className='fa fa-clock-o'></i>
                              {/*{stock.fuel}*/}
                              {stock.fuelType}
                            </li>
                            <li>
                              <i className='fa fa-tachometer'></i>
                              {stock.transmission}
                            </li>
                            <li>
                              <i className='fa fa-road'></i>
                              <CurrencyFormat
                                value={stock.mileage}
                                displayType={"text"}
                                thousandSeparator={true}
                                sufffix={"km"}
                                //format='R### ### ### ###'
                                renderText={(value) => (
                                  <div style={{ display: "inline-block" }}>
                                    {value}
                                  </div>
                                )}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ) : null;
                })}
              </Slider>
            </div>
          </div>
          <div className='banner-item banner-2x banner-bg-10 color-inher m-b-lg-50'>
            <h3 className='f-weight-300'>
              <strong>New or Pre-owned?</strong>
            </h3>
            <p style={{ margin: "auto" }}>
              Choose from our extensive range of new, pre-owned or demo cars,
              with offers to suit your budget! We are serious about quality –
              all our vehicles pass stringent verification and multi-point
              checks.
            </p>
            <Row
              style={{
                maxWidth: "90em",
                margin: "auto",
                marginTop: "3em",
                textAlign: "center",
              }}
            >
              <Col span={8}>
                {" "}
                <Fade left>
                  <Card
                    bordered={false}
                    hoverable
                    style={{
                      width: "20em",
                      padding: "1.5em",
                      paddingTop: "3em",
                      margin: "auto",
                      borderRadius: "1em",
                    }}
                    cover={
                      <span>
                        <Meta
                          title='New Cars'
                          description='Choose from our extensive range of new cars.'
                        />
                        <Link to={"/stock"}>
                          <Button size='large' style={{ marginTop: "1.7em" }}>
                            Search Now
                          </Button>
                        </Link>
                      </span>
                    }
                  >
                    <img style={{ width: "10em" }} alt='example' src={NewCar} />
                  </Card>{" "}
                </Fade>
              </Col>

              <Col span={8}>
                {" "}
                <Fade bottom>
                  <Card
                    bordered={false}
                    hoverable
                    style={{
                      width: "20em",
                      padding: "1.5em",
                      paddingTop: "3em",
                      margin: "auto",
                      borderRadius: "1em",
                    }}
                    cover={
                      <span>
                        <Meta
                          title='Used Cars'
                          description='Choose from our extensive range of quality pre-owned cars.'
                        />
                        <Link to={"/stock"}>
                          <Button size='large' style={{ marginTop: "1.7em" }}>
                            Search Now
                          </Button>
                        </Link>
                      </span>
                    }
                  >
                    <img
                      style={{ width: "10em" }}
                      alt='example'
                      src={UsedCar}
                    />
                  </Card>{" "}
                </Fade>
              </Col>

              <Col span={8}>
                {" "}
                <Fade right>
                  <Card
                    bordered={false}
                    hoverable
                    style={{
                      width: "20em",
                      padding: "1.5em",
                      paddingTop: "3em",
                      margin: "auto",
                      borderRadius: "1em",
                    }}
                    cover={
                      <span>
                        <Meta
                          title='Demo Cars'
                          description='Choose from our extensive range of demo cars.'
                        />
                        <Link to={"/stock"}>
                          <Button size='large' style={{ marginTop: "1.7em" }}>
                            Search Now
                          </Button>
                        </Link>
                      </span>
                    }
                  >
                    <img
                      style={{ width: "10em" }}
                      alt='example'
                      src={DemoCar}
                    />
                  </Card>{" "}
                </Fade>
              </Col>
            </Row>
          </div>
          <div className=''>
            <div style={{ backgroundColor: "#F2F4F4" }}>
              <Row
                justify='center'
                style={{
                  maxWidth: "60em",
                  margin: "auto",
                  paddingTop: "2em",
                  paddingBottom: "3em",
                }}
              >
                <Col span={4}>
                  <img
                    src={ThinkImg}
                    alt='Logo'
                    style={{
                      display: "inline",

                      width: "23em",
                      marginTop: "-5.8em",
                      marginBottom: "-11em",
                      marginLeft: "-15em",
                    }}
                  />
                </Col>
                <Col span={16}>
                  <h6 style={{ textAlign: "left" }}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/logo.png`}
                      alt='logo'
                      style={{ width: "8em", marginTop: "-1em" }}
                    />
                    {/*Recommender*/}
                  </h6>
                  <h1
                    style={{
                      textAlign: "left",
                      fontSize: "30px",
                      lineHeight: "0.2em",
                    }}
                  >
                    Not Sure Which Car to buy?
                  </h1>
                  <p
                    style={{
                      textAlign: "left",
                      color: "#4F5665",
                      fontSize: "15px",
                      lineHeight: "1em",
                    }}
                  >
                    Let’s help to get you driving away in your perfect car.
                  </p>
                </Col>
                <Col span={4}>
                  <Link to={"/contactUs"}>
                    <Button
                      style={{
                        fontFamily: "Nunito",
                        border: "1px solid #F91700",
                        fontSize: "15px",
                        fontWeight: 600,
                        borderRadius: "0.3em",
                        backgroundColor: "#F91700",
                        color: "white",
                        height: "55px",
                        paddingTop: "0.2em",
                        paddingLeft: "3em",
                        paddingRight: "3em",
                        textShadow: "none",
                        margin: "auto",
                        marginTop: "3em",
                        marginLeft: "2em",
                      }}
                      type='primary'
                      htmlType='submit'
                    >
                      Chat to a specialist
                    </Button>
                  </Link>
                </Col>
              </Row>
            </div>
          </div>
          <div className='banner-item banner-2x banner-bg-10 color-inher'>
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              alt='logo'
              style={{ width: "12em", marginBottom: "1em" }}
            />
            <h3 className='f-weight-300'>
              <strong>
                Trusted by <span style={{ color: "#F91700" }}>the best</span>
              </strong>
            </h3>
            <p style={{ margin: "auto" }}>View our trusted branches.</p>
            <Row
              style={{
                maxWidth: "80em",
                margin: "auto",
                marginTop: "1em",
                textAlign: "center",
                color: "white",
              }}
            >
              <Col span={8} style={{ padding: "1.5em" }}>
                <Fade left>
                  <div className='banner-bg-mt'>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/logo-total-white.png`}
                      alt='logo'
                      style={{ width: "15em" }}
                    />
                    <p style={{ fontSize: "13px", marginTop: "1em" }}>
                      We believe movement inspires ideas. In pursuing New
                      experiences. Get moving. Get inspired. Schedule A Service.
                    </p>
                    <ul>
                      <h6
                        className='f-weight-400'
                        style={{ textAlign: "left", marginTop: "1em" }}
                      >
                        Pre-Owned Branches:
                      </h6>

                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Potchefstroom
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/mahikeng' style={{ fontSize: "20px" }}>*/}
                        Mahikeng
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Lichtenburg
                        {/*</Link>*/}
                      </li>
                    </ul>
                  </div>
                </Fade>
              </Col>
              <Col span={8} style={{ padding: "1.5em" }}>
                <Fade bottom>
                  <div className='banner-bg-kia'>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/kia-white.png`}
                      alt='logo'
                      style={{ width: "12em" }}
                    />
                    <p style={{ fontSize: "13px", marginTop: "1em" }}>
                      We believe movement inspires ideas. In pursuing New
                      experiences. Get moving. Get inspired in. Schedule A
                      Service.
                    </p>
                    <ul>
                      <h6
                        className='f-weight-400'
                        style={{ textAlign: "left", marginTop: "1em" }}
                      >
                        Branches
                      </h6>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "-1em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/mahikeng' style={{ fontSize: "20px" }}>*/}
                        Mahikeng
                        {/*</Link>*/}
                      </li>
                    </ul>
                  </div>
                </Fade>
              </Col>
              <Col span={8} style={{ padding: "1.5em" }}>
                {" "}
                <Fade right>
                  <div className='banner-bg-mahindra'>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/mahindra-white.png`}
                      alt='logo'
                      style={{ width: "12em" }}
                    />
                    <p style={{ fontSize: "13px", marginTop: "1em" }}>
                      We believe movement inspires ideas. In pursuing New
                      experiences. Get moving. Get inspired. Schedule A Service.
                    </p>
                    <ul>
                      <h6
                        className='f-weight-400'
                        style={{ textAlign: "left", marginTop: "1em" }}
                      >
                        Branches
                      </h6>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "-1em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/mahikeng' style={{ fontSize: "20px" }}>*/}
                        Mahikeng
                        {/*</Link>*/}
                      </li>
                    </ul>
                  </div>
                </Fade>
              </Col>
            </Row>
            <Row
              style={{
                maxWidth: "80em",
                margin: "auto",
                textAlign: "center",
                color: "white",
              }}
            >
              <Col span={8} style={{ padding: "1.5em" }}>
                <Fade left>
                  <div className='banner-bg-chery'>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/chery-white.png`}
                      alt='logo'
                      style={{ width: "12em" }}
                    />
                    <p style={{ fontSize: "13px", marginTop: "1em" }}>
                      We believe movement inspires ideas. In pursuing New
                      experiences. Get moving. Get inspired. Schedule A Service.
                    </p>
                    <ul>
                      <h6
                        className='f-weight-400'
                        style={{ textAlign: "left", marginTop: "1em" }}
                      >
                        Branches
                      </h6>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "-1em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Klerksdorp
                        {/*</Link>*/}
                      </li>
                    </ul>
                  </div>
                </Fade>
              </Col>
              <Col span={8} style={{ padding: "1.5em" }}>
                {" "}
                <Fade bottom>
                  <div className='banner-bg-gwm'>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/gwm-white.png`}
                      alt='logo'
                      style={{ width: "12em" }}
                    />
                    <p style={{ fontSize: "13px", marginTop: "1em" }}>
                      We believe movement inspires ideas. In pursuing New
                      experiences. Get moving. Get inspired. Schedule A Service.
                    </p>
                    <ul>
                      <h6
                        className='f-weight-400'
                        style={{ textAlign: "left", marginTop: "1em" }}
                      >
                        Branches
                      </h6>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "-1em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Klerksdorp
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Potchefstroom
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/mahikeng' style={{ fontSize: "20px" }}>*/}
                        Mahikeng
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Lichtenburg
                        {/*</Link>*/}
                      </li>
                    </ul>
                  </div>
                </Fade>
              </Col>
              <Col span={8} style={{ padding: "1.5em" }}>
                <Fade right>
                  <div className='banner-bg-haval'>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/haval-white.png`}
                      alt='logo'
                      style={{ width: "12em" }}
                    />
                    <p style={{ fontSize: "13px", marginTop: "1em" }}>
                      We believe movement inspires ideas. In pursuing New
                      experiences. Get moving. Get inspired. Schedule A Service.
                    </p>
                    <ul>
                      <h6
                        className='f-weight-400'
                        style={{ textAlign: "left", marginTop: "1em" }}
                      >
                        Branches
                      </h6>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "-1em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Klerksdorp
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Potchefstroom
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/mahikeng' style={{ fontSize: "20px" }}>*/}
                        Mahikeng
                        {/*</Link>*/}
                      </li>
                      <li
                        onClick={onClickBranch}
                        className='f-weight-600 branch-name'
                        style={{
                          textAlign: "left",
                          marginTop: "0em",
                          fontSize: "20px",
                        }}
                      >
                        {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                        Lichtenburg
                        {/*</Link>*/}
                      </li>
                    </ul>
                  </div>
                </Fade>
              </Col>
            </Row>{" "}
            <Fade bottom>
              <Row
                className='banner-bg-service'
                style={{
                  maxWidth: "77em",
                  margin: "auto",
                  marginTop: "1.5em",
                  textAlign: "left",
                  color: "white",
                  padding: "0em",
                }}
              >
                <Col
                  span={12}
                  style={{ padding: "3.5em", paddingTop: "4.5em" }}
                >
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/logo-white.png`}
                      alt='logo'
                      style={{ width: "16em" }}
                    />
                    <h3 className='f-weight-300' style={{ marginTop: "0.3em" }}>
                      <strong>Service Centers</strong>
                      <br />
                    </h3>
                    <p style={{ fontSize: "13px", marginTop: "0.7em" }}>
                      We believe movement inspires ideas. In pursuing New
                      experiences. Get moving. Get inspired. Schedule A Service.
                    </p>
                  </div>
                </Col>
                <Col span={6} style={{ paddinLeft: "1.5em" }}>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "1em" }}
                    >
                      KLERKSDORP
                    </h6>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Chery
                      {/*</Link>*/}
                    </li>{" "}
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      GWM
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      HAVAL
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      JAC
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Used
                      {/*</Link>*/}
                    </li>
                  </ul>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "-1em" }}
                    >
                      Potchefstroom
                    </h6>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      GWM
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      HAVAL
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Used
                      {/*</Link>*/}
                    </li>
                  </ul>
                </Col>
                <Col span={6} style={{}}>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{
                        textAlign: "left",
                        marginTop: "1em",
                      }}
                    >
                      MAHIKENG
                    </h6>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Kia
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Mahindra
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      GWM
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      HAVAL
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Used
                      {/*</Link>*/}
                    </li>
                  </ul>
                </Col>
              </Row>
            </Fade>
          </div>
          <Row style={{ maxWidth: "85em", margin: "auto" }}>
            <Col span={12}>
              <div
                style={{ height: "31em" }}
                className='banner-item banner-2x banner-bg-express-store  m-b-lg-50'
              >
                <div
                  className='m-b-lg-10'
                  style={{ fontSize: "20px", color: "#F91700" }}
                >
                  <i className='fa fa-shopping-cart' aria-hidden='true'></i>{" "}
                  EXPRESS STORE
                </div>
                <h3 className='f-weight-300'>
                  <strong> Safe & Secure</strong>
                  <br />
                  <span style={{ fontSize: "23px" }}>
                    Accessories Bying Made Simple
                  </span>
                </h3>
                <p>Instant Pricing - No Hassle - Safe & Secure</p>
                <a className='ht-btn ht-btn-default'>Launching Soon</a>
              </div>
            </Col>

            <Col span={12}>
              <div
                style={{ height: "31em" }}
                className='banner-item banner-2x banner-bg-service-center color-inher m-b-lg-50'
              >
                <div
                  className='m-b-lg-10'
                  style={{ fontSize: "20px", color: "white" }}
                >
                  <i className='fa fa-wrench' aria-hidden='true'></i> SERVICE
                  CENTER
                </div>
                <h3 className='f-weight-300'>
                  <strong> Book a Service </strong>
                  <br />
                  <span style={{ fontSize: "23px" }}>
                    Get a Service Your Car Deserves
                  </span>
                </h3>
                <p>Car in need of a service? Book one now.</p>
                <Link to={"/bookService"}>
                  <a className='ht-btn ht-btn-white'>Book Service</a>
                </Link>
              </div>
            </Col>
          </Row>
        </div>{" "}
        <div className='wrap-body-inner mobile-view'>
          <div>
            {/*<section className='block-sl'>
            <div className='container-custom'>
              <div className='row'>
                <div className='col-sm-5 col-md-5 col-lg-5'>
                  <div className='banner-item-home banner-2x-home no-bg color-inher-home'>
                    <h1 className='f-weight-600'>
                      PURCHASE YOUR <br />
                    </h1>
                    <h1 style={{ color: "red" }}>PERFECT STOCK</h1>
                    <p>
                      Mega Theron Group makes it easy to drive your dream
                      stock at the best prices possible.
                    </p>
                    <Link
                  to={"/stock"}
                  className="ht-btn ht-btn-default ht-btn-2x m-t-lg-35"
                >
                  View all stock
                </Link>
                  </div>
                </div>
                <div className='col-sm-6 col-md-6 col-lg-6'>
                  <img
                    className='banner-img-home'
                    style={{ width: "50em" }}
                      src={`${process.env.PUBLIC_URL}/images/home-banner.png`}
                    alt='logo'
                  />
                </div>
              </div>
            </div>
          </section>*/}
            {/*<SearchBarHome filters={this.getFilters.bind(this)} />*/}
          </div>
          <div
            className='product product-grid product-grid-2 stock m-t-lg-50 p-t-sm-35 m-b-lg-0 '
            style={{ zIndex: 999 }}
          >
            <div className='heading'>
              <h3>Promotions</h3>
            </div>
            <div className='row'>
              <Slider {...settings}>
                {this.state.stock.map((stock, index, props) => {
                  return stock.webVisible && stock.homeVisible ? (
                    <div className='col-lg-12' key={index}>
                      <div
                        className='product-item hover-img '
                        style={{ maxWidth: "21em", margin: "auto" }}
                      >
                        {/*<i
                          id={JSON.stringify(stock)}
                          //className={
                          //  this.state.isInWishList ? "fa fa-heart" : "fa fa-heart-o"
                          //}
                          className={"fa fa-heart"}
                          style={{
                            background: "#ecececbe",
                            borderRadius: "0em 0em 0em 0.8em",
                            padding: "1em",
                            position: "absolute",
                            right: 0,
                            top: 0,
                            color: this.state.isInWishList ? "red" : "grey",
                          }}
                          onClick={this.ToggleCarWishlist.bind(this)}
                        />*/}
                        {stock.onSale === true ? (
                          <span
                            style={{
                              background: "rgb(254, 95, 92)",
                              borderRadius: "5em",
                              padding: "0.7em",
                              paddingTop: "1.1em",
                              paddingBottom: "1em",
                              position: "absolute",
                              left: 10,
                              top: 10,
                              color: "white",
                              fontSize: 11,
                            }}
                          >
                            SALE
                          </span>
                        ) : null}
                        {stock.condition ? (
                          <span
                            style={{
                              background:
                                stock.condition === "New"
                                  ? "rgba(254, 95, 92, 0.829)"
                                  : stock.condition === "Demo"
                                  ? "rgba(109, 109, 109, 0.829)"
                                  : "rgba(109, 109, 109, 0.829)",
                              borderRadius: "0em",
                              padding: "0.3em",
                              paddingRight: "0.8em",
                              paddingLeft: "0.8em",
                              position: "absolute",
                              right: 10,
                              top: 158,
                              width: "4.3em",
                              color: "white",
                            }}
                          >
                            {stock.condition.toUpperCase()}
                          </span>
                        ) : null}
                        {stock.modelYear ? (
                          <span
                            style={{
                              background: "rgba(0, 0, 0, 0.529)",
                              borderRadius: "0em",
                              padding: "0.3em",
                              paddingRight: "0.8em",
                              paddingLeft: "0.8em",
                              position: "absolute",
                              right: stock.condition ? 75 : 10,
                              top: 158,
                              color: "white",
                            }}
                          >
                            {stock.modelYear}
                          </span>
                        ) : null}
                        <Link
                          className='product-img'
                          onClick={() => this.props.fetchSingleStock(stock)}
                          to={`/stocko`}
                        >
                          {stock.frontLeftImage ? (
                            <img
                              src={`${process.env.REACT_APP_GLOBAL_SERVER}mtgroup/api/images/${stock.frontLeftImage}`}
                              alt=''
                            />
                          ) : (
                            <img
                              src={`${process.env.PUBLIC_URL}/images/coming-soon.png`}
                              alt=''
                            />
                          )}
                        </Link>
                        <div className='product-caption'>
                          <h4
                            className='product-name'
                            style={{ marginBottom: "0em", marginTop: "-1em" }}
                          >
                            <Link
                              onClick={() => this.props.fetchSingleStock(stock)}
                              to={`/stocko`}
                            >
                              <span style={{ display: "block" }}>
                                {stock.make}
                                <p
                                  className='f-14'
                                  style={{
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    paddingRight: "3em",
                                    overflow: "hidden",
                                    width: "21em",
                                  }}
                                >
                                  {/*{stock.series} 
                              <br />*/}
                                  {stock.modelDesc}
                                </p>
                              </span>
                            </Link>
                          </h4>
                          <div className='product-name'>
                            <span
                              className='f-15 m-t-lg-5'
                              style={{
                                float: "left",
                                textAlign: "left",
                                fontWeight: 400,
                                color: "black",
                              }}
                            >
                              {stock.branchImage ? (
                                <img
                                  src={`${process.env.REACT_APP_GLOBAL_SERVER}mtgroup/api/images/${stock.branchImage}`}
                                  alt=''
                                  style={{
                                    position: "absolute",
                                    marginTop: "-2.3em",
                                    objectFit: "cover",
                                    height: "2em",
                                  }}
                                />
                              ) : (
                                <span
                                  style={{
                                    textAlign: "left",
                                    position: "absolute",
                                    marginTop: window.isPhone
                                      ? "-2em"
                                      : "-1.5em",
                                    left: 0,
                                  }}
                                >
                                  {stock.brand}
                                </span>
                              )}
                              {stock.branch}
                            </span>
                            <span
                              className='f-23  m-t-lg-0 mn-cl'
                              style={{ float: "right" }}
                            >
                              <CurrencyFormat
                                value={stock.price}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"R"}
                                //format='R### ### ### ###'
                                renderText={(value) => <div>{value}</div>}
                              />
                            </span>
                          </div>
                          <ul className='static-caption m-t-lg-20'>
                            <li>
                              <i className='fa fa-clock-o'></i>
                              {/*{stock.fuel}*/}
                              {stock.fuelType}
                            </li>
                            <li>
                              <i className='fa fa-tachometer'></i>
                              {stock.transmission}
                            </li>
                            <li>
                              <i className='fa fa-road'></i>
                              <CurrencyFormat
                                value={stock.mileage}
                                displayType={"text"}
                                thousandSeparator={true}
                                sufffix={"km"}
                                //format='R### ### ### ###'
                                renderText={(value) => (
                                  <div style={{ display: "inline-block" }}>
                                    {value}
                                  </div>
                                )}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ) : null;
                })}
              </Slider>
            </div>
          </div>
          <div className='banner-item banner-2x banner-bg-10 color-inher m-b-lg-0'>
            <h3 className='f-weight-300'>
              <strong>New or Pre-owned?</strong>
            </h3>
            <p style={{ margin: "auto" }}>
              Choose from our extensive range of new, pre-owned or demo cars,
              with offers to suit your budget! We are serious about quality –
              all our vehicles pass stringent verification and multi-point
              checks.
            </p>
            <Row
              style={{
                maxWidth: "90em",
                margin: "auto",
                marginTop: "3em",
                textAlign: "center",
              }}
            >
              <Col span={24}>
                <Card
                  bordered={false}
                  hoverable
                  style={{
                    width: "20em",
                    padding: "1.5em",
                    paddingTop: "3em",
                    margin: "auto",
                    borderRadius: "1em",
                  }}
                  cover={
                    <span>
                      <Meta
                        title='New Cars'
                        description='Choose from our extensive range of new cars.'
                      />
                      <Link to={"/stock"}>
                        <Button size='large' style={{ marginTop: "1.7em" }}>
                          Search Now
                        </Button>
                      </Link>
                    </span>
                  }
                >
                  <img style={{ width: "10em" }} alt='example' src={NewCar} />
                </Card>
              </Col>
              <Col span={24}>
                <Card
                  bordered={false}
                  hoverable
                  style={{
                    width: "20em",
                    padding: "1.5em",
                    paddingTop: "3em",
                    margin: "auto",
                    borderRadius: "1em",
                  }}
                  cover={
                    <span>
                      <Meta
                        title='Used Cars'
                        description='Choose from our extensive range of quality pre-owned cars.'
                      />
                      <Link to={"/stock"}>
                        <Button size='large' style={{ marginTop: "1.7em" }}>
                          Search Now
                        </Button>
                      </Link>
                    </span>
                  }
                >
                  <img style={{ width: "10em" }} alt='example' src={UsedCar} />
                </Card>
              </Col>
              <Col span={24}>
                <Card
                  bordered={false}
                  hoverable
                  style={{
                    width: "20em",
                    padding: "1.5em",
                    paddingTop: "3em",
                    margin: "auto",
                    borderRadius: "1em",
                  }}
                  cover={
                    <span>
                      <Meta
                        title='Demo Cars'
                        description='Choose from our extensive range of demo cars.'
                      />
                      <Link to={"/stock"}>
                        <Button size='large' style={{ marginTop: "1.7em" }}>
                          Search Now
                        </Button>
                      </Link>
                    </span>
                  }
                >
                  <img style={{ width: "10em" }} alt='example' src={DemoCar} />
                </Card>
              </Col>
            </Row>
          </div>
          <div className=''>
            <div style={{ backgroundColor: "#F2F4F4", margin: "auto" }}>
              <Row
                justify='center'
                style={{
                  maxWidth: "60em",
                  margin: "auto",
                  paddingTop: "2em",
                  paddingBottom: "3em",
                }}
              >
                <Col span={24} style={{ textAlign: "center" }}>
                  <img
                    src={ThinkImg}
                    alt='Logo'
                    style={{
                      display: "inline",

                      width: "23em",
                      //marginTop: "-6.5em",
                      //marginBottom: "-11em",
                      //marginLeft: "-15em",
                    }}
                  />
                </Col>
                <Col span={24}>
                  <h6 style={{ textAlign: "center" }}>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/logo.png`}
                      alt='logo'
                      style={{ width: "8em", marginTop: "0em" }}
                    />
                    <br /> <br />
                    Recommender
                  </h6>
                  <h1
                    style={{
                      textAlign: "center",
                      fontSize: "35px",
                      lineHeight: "1em",
                    }}
                  >
                    Not Sure Which Car to buy?
                  </h1>
                  <p
                    style={{
                      textAlign: "center",
                      color: "#4F5665",
                      fontSize: "15px",
                      lineHeight: "1em",
                    }}
                  >
                    Let’s help to get you driving away in your perfect car.
                  </p>
                </Col>
                <Col span={24} style={{ textAlign: "center" }}>
                  <Link to={"/contactUs"}>
                    <Button
                      style={{
                        fontFamily: "Nunito",
                        border: "1px solid #F91700",
                        fontSize: "15px",
                        fontWeight: 600,
                        borderRadius: "0.3em",
                        backgroundColor: "#F91700",
                        color: "white",
                        height: "55px",
                        paddingTop: "0.2em",
                        paddingLeft: "3em",
                        paddingRight: "3em",
                        textShadow: "none",
                        margin: "auto",
                        marginTop: "2em",
                      }}
                      type='primary'
                      htmlType='submit'
                    >
                      Chat to a specialist
                    </Button>
                  </Link>
                </Col>
              </Row>
            </div>
          </div>
          <div className='banner-item banner-2x banner-bg-10 color-inher'>
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              alt='logo'
              style={{ width: "12em", marginBottom: "1em" }}
            />
            <h3 className='f-weight-300'>
              <strong style={{ lineHeight: "0em" }}>
                Trusted by
                <br />
                <span style={{ color: "#F91700" }}>the best</span>
              </strong>
            </h3>
            <p style={{ margin: "auto" }}>View our trusted branches.</p>
            <Row
              style={{
                maxWidth: "80em",
                margin: "auto",
                marginTop: "1em",
                textAlign: "center",
                color: "white",
              }}
            >
              <Col span={24} style={{ padding: "0em", marginBottom: "1em" }}>
                <div className='banner-bg-mt'>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logo-total-white.png`}
                    alt='logo'
                    style={{ width: "12em" }}
                  />
                  <p style={{ fontSize: "13px", marginTop: "1em" }}>
                    We believe movement inspires ideas. In pursuing New
                    experiences. Get moving. Get inspired. Schedule A Service.
                  </p>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "1em" }}
                    >
                      Pre-Owned Branches:
                    </h6>

                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Potchefstroom
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/mahikeng' style={{ fontSize: "20px" }}>*/}
                      Mahikeng
                      {/*</Link>*/}
                    </li>
                    <li
                      onClick={onClickBranch}
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "0em",
                        fontSize: "20px",
                      }}
                    >
                      {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                      Lichtenburg
                      {/*</Link>*/}
                    </li>
                  </ul>
                </div>
              </Col>
              <Col span={24} style={{ padding: "0em", marginBottom: "1em" }}>
                <div className='banner-bg-kia'>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/kia-white.png`}
                    alt='logo'
                    style={{ width: "12em" }}
                  />
                  <p style={{ fontSize: "13px", marginTop: "1em" }}>
                    We believe movement inspires ideas. In pursuing New
                    experiences. Get moving. Get inspired. Schedule A Service.
                  </p>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "1em" }}
                    >
                      Branches
                    </h6>
                    <li
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      <Link to='/mahikeng' style={{ fontSize: "20px" }}>
                        Mahikeng
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col span={24} style={{ padding: "0em", marginBottom: "1em" }}>
                <div className='banner-bg-mahindra'>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/mahindra-white.png`}
                    alt='logo'
                    style={{ width: "12em" }}
                  />
                  <p style={{ fontSize: "13px", marginTop: "1em" }}>
                    We believe movement inspires ideas. In pursuing New
                    experiences. Get moving. Get inspired. Schedule A Service.
                  </p>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "1em" }}
                    >
                      Branches
                    </h6>
                    <li
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      <Link to='/mahikeng' style={{ fontSize: "20px" }}>
                        Mahikeng
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
            <Row
              style={{
                maxWidth: "80em",
                margin: "auto",
                textAlign: "center",
                color: "white",
              }}
            >
              <Col span={24} style={{ padding: "0em", marginBottom: "1em" }}>
                <div className='banner-bg-chery'>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/chery-white.png`}
                    alt='logo'
                    style={{ width: "12em" }}
                  />
                  <p style={{ fontSize: "13px", marginTop: "1em" }}>
                    We believe movement inspires ideas. In pursuing New
                    experiences. Get moving. Get inspired. Schedule A Service.
                  </p>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "1em" }}
                    >
                      Branches
                    </h6>
                    <li
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                        Klerksdorp
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col span={24} style={{ padding: "0em", marginBottom: "1em" }}>
                <div className='banner-bg-gwm'>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/gwm-white.png`}
                    alt='logo'
                    style={{ width: "12em" }}
                  />
                  <p style={{ fontSize: "13px", marginTop: "1em" }}>
                    We believe movement inspires ideas. In pursuing New
                    experiences. Get moving. Get inspired. Schedule A Service.
                  </p>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "1em" }}
                    >
                      Branches
                    </h6>
                    <li
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                        Klerksdorp
                      </Link>
                    </li>
                    <li
                      className='f-weight-600 branch-name'
                      style={{ textAlign: "left", marginTop: "0em" }}
                    >
                      <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                        Potchefstroom
                      </Link>
                    </li>
                    <li
                      className='f-weight-600 branch-name'
                      style={{ textAlign: "left", marginTop: "0em" }}
                    >
                      <Link to='/mahikeng' style={{ fontSize: "20px" }}>
                        Mahikeng
                      </Link>
                    </li>
                    <li
                      className='f-weight-600 branch-name'
                      style={{ textAlign: "left", marginTop: "0em" }}
                    >
                      <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                        Lichtenburg
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col span={24} style={{ padding: "0em", marginBottom: "1em" }}>
                <div className='banner-bg-haval'>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/haval-white.png`}
                    alt='logo'
                    style={{ width: "12em" }}
                  />
                  <p style={{ fontSize: "13px", marginTop: "1em" }}>
                    We believe movement inspires ideas. In pursuing New
                    experiences. Get moving. Get inspired. Schedule A Service.
                  </p>
                  <ul>
                    <h6
                      className='f-weight-400'
                      style={{ textAlign: "left", marginTop: "1em" }}
                    >
                      Branches
                    </h6>
                    <li
                      className='f-weight-600 branch-name'
                      style={{
                        textAlign: "left",
                        marginTop: "-1em",
                        fontSize: "20px",
                      }}
                    >
                      <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                        Klerksdorp
                      </Link>
                    </li>
                    <li
                      className='f-weight-600 branch-name'
                      style={{ textAlign: "left", marginTop: "0em" }}
                    >
                      <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                        Potchefstroom
                      </Link>
                    </li>
                    <li
                      className='f-weight-600 branch-name'
                      style={{ textAlign: "left", marginTop: "0em" }}
                    >
                      <Link to='/mahikeng' style={{ fontSize: "20px" }}>
                        Mahikeng
                      </Link>
                    </li>
                    <li
                      className='f-weight-600 branch-name'
                      style={{ textAlign: "left", marginTop: "0em" }}
                    >
                      <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                        Lichtenburg
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
            <Row
              className='banner-bg-service'
              style={{
                maxWidth: "77em",
                margin: "auto",
                textAlign: "left",
                color: "white",
                padding: "0em",
              }}
            >
              <Col
                span={24}
                style={{
                  padding: "3.5em",
                  paddingTop: "2.5em",
                  textAlign: "center",
                }}
              >
                <div>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logo-white.png`}
                    alt='logo'
                    style={{ width: "100%" }}
                  />
                  <h3 className='f-weight-300' style={{ marginTop: "0.3em" }}>
                    <strong>Service Centers</strong>
                    <br />
                  </h3>
                  <p style={{ fontSize: "13px", marginTop: "0.7em" }}>
                    We believe movement inspires ideas. In pursuing New
                    experiences. Get moving. Get inspired. Schedule A Service.
                  </p>
                </div>
              </Col>
              <Col span={24} style={{ paddinLeft: "1.5em" }}>
                <ul>
                  <h6
                    className='f-weight-400'
                    style={{ textAlign: "center", marginTop: "1em" }}
                  >
                    KLERKSDORP
                  </h6>
                  <li
                    onClick={onClickBranch}
                    className='f-weight-600 branch-name'
                    style={{
                      textAlign: "center",
                      marginTop: "-1em",
                      fontSize: "20px",
                    }}
                  >
                    {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                    Chery
                    {/*</Link>*/}
                  </li>{" "}
                  <li
                    onClick={onClickBranch}
                    className='f-weight-600 branch-name'
                    style={{
                      textAlign: "center",
                      marginTop: "0em",
                      fontSize: "20px",
                    }}
                  >
                    {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                    GWM
                    {/*</Link>*/}
                  </li>
                  <li
                    onClick={onClickBranch}
                    className='f-weight-600 branch-name'
                    style={{
                      textAlign: "center",
                      marginTop: "0em",
                      fontSize: "20px",
                    }}
                  >
                    {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                    HAVAL
                    {/*</Link>*/}
                  </li>
                  <li
                    onClick={onClickBranch}
                    className='f-weight-600 branch-name'
                    style={{
                      textAlign: "center",
                      marginTop: "0em",
                      fontSize: "20px",
                    }}
                  >
                    {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                    JAC
                    {/*</Link>*/}
                  </li>
                  <li
                    onClick={onClickBranch}
                    className='f-weight-600 branch-name'
                    style={{
                      textAlign: "center",
                      marginTop: "0em",
                      fontSize: "20px",
                    }}
                  >
                    {/*<Link to='/klerksdorp' style={{ fontSize: "20px" }}>*/}
                    Used
                    {/*</Link>*/}
                  </li>
                </ul>
                <ul>
                  <h6
                    className='f-weight-400'
                    style={{ textAlign: "center", marginTop: "1em" }}
                  >
                    Potchefstroom
                  </h6>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "-1em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      GWM
                    </Link>
                  </li>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "0em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      HAVAL
                    </Link>
                  </li>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "0em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      Used
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col span={24} style={{}}>
                <ul>
                  <h6
                    className='f-weight-400'
                    style={{ textAlign: "center", marginTop: "0em" }}
                  >
                    MAHIKENG
                  </h6>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "-1em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      Kia
                    </Link>
                  </li>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "0em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      Mahindra
                    </Link>
                  </li>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "0em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      GWM
                    </Link>
                  </li>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "0em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      HAVAL
                    </Link>
                  </li>
                  <li
                    className='f-weight-600 branch-name'
                    style={{ textAlign: "center", marginTop: "0em" }}
                  >
                    <Link to='/klerksdorp' style={{ fontSize: "20px" }}>
                      Used
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
          <Row style={{ maxWidth: "85em", margin: "auto" }}>
            <Col span={24}>
              <div
                style={{ height: "31em" }}
                className='banner-item banner-2x banner-bg-express-store  m-b-lg-50'
              >
                <div
                  className='m-b-lg-10'
                  style={{ fontSize: "20px", color: "#F91700" }}
                >
                  <i className='fa fa-shopping-cart' aria-hidden='true'></i>{" "}
                  EXPRESS STORE
                </div>
                <h3 className='f-weight-300'>
                  <strong> Safe & Secure</strong>
                  <br />
                  <span style={{ fontSize: "23px" }}>
                    Accessories Bying Made Simple
                  </span>
                </h3>
                <p>Instant Pricing - No Hassle - Save & Secure</p>
                <a className='ht-btn ht-btn-default'>Launching Soon</a>
              </div>
            </Col>

            <Col span={24}>
              <div
                style={{ height: "31em" }}
                className='banner-item banner-2x banner-bg-service-center color-inher m-b-lg-50'
              >
                <div
                  className='m-b-lg-10'
                  style={{ fontSize: "20px", color: "white" }}
                >
                  <i className='fa fa-wrench' aria-hidden='true'></i> SERVICE
                  CENTER
                </div>
                <h3 className='f-weight-300'>
                  <strong> Book a Service </strong>
                  <br />
                  <span style={{ fontSize: "23px" }}>
                    Get a Service Your Car Deserves
                  </span>
                </h3>
                <p>Car in need of a service? Book one now.</p>
                <Link to={"/bookService"}>
                  <a className='ht-btn ht-btn-white'>Book Service</a>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
        <BackTop />
      </div>
    );
  }
}

function mapStateToProps({ wishlistproducts }) {
  return { wishlistproducts };
}

export default connect(mapStateToProps, {
  fetchSingleStock,
  addToWishList,
  removeFromWishList,
})(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js